import { Dynamic } from '#pplx/frontend/dynamic/Dynamic.js';
export const loadSearchPage = async () => {
    const { SearchPage } = await import('#pplx/frontend/apps/ask/page-components/search/search-component.js');
    return { default: SearchPage };
};
const SearchPagePreloader = Dynamic(loadSearchPage);
export const preloadSearchPage = SearchPagePreloader.preload;
//# sourceMappingURL=search-page-loader.js.map